import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Link} from 'components/ReactRouterDomLocalized';

import {t} from 'l10n';
import paths from 'paths';
import isMobile from 'ismobilejs';

import WallMaterialList from 'components/list/WallMaterialList';
import {memberDeleteWallPost} from 'reducers/member';

import 'sass/member/MemberWallPostsBlock.scss';

class MemberWallPostsBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render(){
        let {wallMaterials, openAddWallPostModal, memberDeleteWallPost} = this.props,
            {list, totalCount} = wallMaterials;

        return (
            <aside className="post-wall-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My posts on The Wall')} <em>{totalCount}</em></h2>
                        <div>
                            {list.length && !isMobile.any ? <Link to={paths.memberWallMaterials.path} className="list-items">{t('All my posts on The Wall')}</Link> : null}
                            <a className="add-item" onClick={openAddWallPostModal}>{t('New post')}</a>
                        </div>
                    </div>

                    <WallMaterialList wallMaterials={list} onDelete={memberDeleteWallPost} responsiveGrid="single-row" showDate showStats altThumbnail/>

                    {(list.length && isMobile.any) ? <Link to={paths.memberWallMaterials.path} className="get-all-wall">{t('All my posts on The Wall')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

//export default MemberWallPostsBlock;
export default connect(
    null,
    ({
        memberDeleteWallPost: memberDeleteWallPost,
    })
)(MemberWallPostsBlock)



// WEBPACK FOOTER //
// ./src/components/member/MemberWallPostsBlock.js